import angular from 'angular'
import forEach from 'lodash/forEach'

import template from './vd-dialog-close.html'

/**
 * A close button to be used with modal dialogs. The action will also be invoked if the Escape key is pressed.
 *
 * @param {Function} action
 *        The action to peform when clicking on the dialog close button - will be invoked with the `$event`
 */
angular.module('vend.ui').directive('vdDialogClose', function (elementService) {
  return {
    scope: {
      action: '=',
      label: '@',
    },
    // Template uses an anchor element instead of a button due to firefox not supporting flex positioning within a button
    template,
    bindToController: true,
    controllerAs: 'vdDialogCloseCtrl',
    link(scope, $element, attrs) {
      const modifiers = elementService.getComponentAttrs(attrs, 'modifier')

      if (modifiers) {
        forEach(modifiers, modifier =>
          attrs.$addClass(`vd-dialog-close--${modifier}`)
        )
      }

      attrs.$addClass('vd-dialog-close')
    },
    controller($scope, vdEscapeStack) {
      this._performAction = () => {
        if (angular.isFunction(this.action)) {
          this.action()
        }
      }

      this.onClick = this._performAction

      vdEscapeStack.register(this._performAction)
      $scope.$on('$destroy', () =>
        vdEscapeStack.deregister(this._performAction)
      )
    },
  }
})
